module.exports = __webpack_public_path__ + "img/arrow-alt-circle-right.f0708eec.svg";